/* eslint-disable @typescript-eslint/no-explicit-any */
import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'safeDate'
})
export class SafeDatePipe implements PipeTransform {

  transform(value: any, format = "MM/yyyy"): string | undefined {
    const date = new Date(value);

    if (isNaN(date.getTime())) {
      return "To Be Determined";
    }
    return new DatePipe("en-US").transform(date, format)?.toString();
  }
}
